import { useCallback, useMemo } from "react";

import useStackAvailableSpaces from "views/Stack/useStackAvailableSpaces";

import { decodeUrlSearchParam } from "./utils";
import { StackCreationWizardStep, StackFormFields } from "./types";
import { INITIAL_STACK_VALUES_SCHEMA } from "./schema";

const useValuesTransformer = () => {
  const availableSpaces = useStackAvailableSpaces();

  return useCallback(
    (values: StackFormFields): StackFormFields => ({
      ...values,
      [StackCreationWizardStep.Details]: {
        ...values[StackCreationWizardStep.Details],
        space:
          availableSpaces.find((s) => s.id === values[StackCreationWizardStep.Details].space)?.id ||
          availableSpaces[0]?.id,
      },
    }),
    [availableSpaces]
  );
};

const useInitialValues = (urlSearchParams: URLSearchParams): StackFormFields => {
  const transformValues = useValuesTransformer();

  const initialValues: StackFormFields = useMemo(() => {
    const searchParamsRecord = decodeUrlSearchParam(urlSearchParams);
    const parsedInputValues = INITIAL_STACK_VALUES_SCHEMA.parse(searchParamsRecord);

    const transformedValues = transformValues(parsedInputValues);

    return transformedValues;
  }, [urlSearchParams, transformValues]);

  return initialValues;
};

export default useInitialValues;
